<template>

    <div id="ReportContainer">
        <transition name="fade" mode="out-in">
            <div v-if="isPrinting" id="printingContainer" key="pinwheel">
                <h5>We are preparing your&nbsp;report</h5>
                <pinwheel></pinwheel>
            </div>
        </transition>
        <div id="PrintContainer" :class="{forPrint:printMode}">
            
            <div class="printRef" ref="reportRef">
                <div class="snapshotContainer" key="header"> 
                    
                    <div class="title">
                        <div class="icon iconPhysical"></div>
                        <div class="titleText">Your Physical Snapshot</div>
                    </div>
                    
                    <div v-if="happinessTell != ''" class="headline">
                        <u>Better sleep</u> could help you say “<u>{{happinessTell}}</u>” more&nbsp;often.
                    </div>
                    <div v-else class="headline">
                        <u>Better sleep</u> could help your overall well-being.
                    </div>
                    <div class="summary" v-html="positives+opportunities"></div>
                    <div class="bodyTalkTitle">What your body is saying:</div>
                    <div class="bodyTalk">
                        Your body is feeling the stress as <u>your BP is a little high.</u> But that’s ok, there are a 
                        few things we can do to get those stress levels down (and keep cardiovascular disease away).
                    </div>
                </div>
                <hr>
                <transition name="fade" mode="out-in">
                    <div v-if="!actionSelected" class="actionsContainer" key="takeCharge">
                        <div class="smallTitle">Take Charge</div>
                        <div class="summary">We found 4 things that could help!<br>Choose 1 to focus on & we’ll help you do it.</div>
                        <div class="actionCardsContainer">
                            <div class="card sleepCard" @click="actionCard"></div>
                            <div class="card eatCard disabled"></div>
                            <div class="card moveCard disabled"></div>
                            <div class="card stressCard disabled"></div>
                        </div>
                        <div class="scrollInstruction" :class="{hidden:didScroll}">
                            Scroll down for more
                            <div class="arrow"></div>
                        </div>
                    </div>
                    <div v-if="actionSelected" class="actionsContainer sleepActions" key="takeAction">
                        <div class="title">
                            <div class="icon iconSleep"></div>
                            <div class="titleText">Sleep Suggestions</div>
                        </div>

                        <template v-if="recommendation=='discipline'">
                            <div class="summary">Get better sleep by <u>getting into a routine.</u></div>
                            <div class="copy">By getting your body into a rhythm, it will learn when to naturally wake up. This means you will feel less groggy as you won’t have melatonin in your blood stream, a hormone that naturally promotes sleep.</div>
                            <div class="howTitle">You can do this by</div>
                            <div class="how copy">
                                Make sure you go to sleep and wake up at the same time every single day (yes, even the weekends).<br><br>
                                Creating a routine to help you wind down at the end of a day.
                            </div>
                            <div class="readMore">
                                <div class="readMoretitle">Read More Online</div>
                                <div class="readMoreLink">cvshealth.com/sleep</div>
                            </div>
                            <div class="actions">
                                <div class="howTitle">Track your sleep:</div>
                                <div class="actionItem">
                                    <div class="title">Track your sleep routine on Paper</div>
                                    <div class="summary">Write down what time you go to sleep and wke up every day.</div>
                                    <div class="link">Download at sleepsweet.com</div>
                                </div>
                                <div class="actionItem">
                                    <div class="title">Sleep As Android App</div>
                                    <div class="summary">Sleep Cycle is an intelligent alarm clock that tracks your sleep patterns and wakes you up in light sleep - the natural way to wake up, feeling rested and energised.</div>
                                </div>
                                <hr>
                                <div class="howTitle">Use wind-down products before bed:</div>
                                <div class="actionItem">
                                    <div class="image imageBigelow"></div>
                                    <div class="title">Bigelow Sweet Dreams&nbsp;Tea</div>
                                    <div class="summary">This tea has a calming full bodied floral lavender flavor with sweet chamomile finish to send you off to dreamland with a smile on your face.</div>
                                    <div class="price">$3</div>
                                    <div class="tags">
                                        <div class="tag">FOOD & SNACKS</div>
                                        <div class="tag">AISLE B1</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                                <div class="actionItem">
                                    <div class="image imageDiffuser"></div>
                                    <div class="title">Art Naturals Essential Oils & Diffuser</div>
                                    <div class="summary">Transform the quality of your home into a pleasantly fragranced environment with this standard cool mist aromatherapy essential oil Diffuser.</div>
                                    <div class="price">$22</div>
                                    <div class="tags">
                                        <div class="tag">VITAMINS</div>
                                        <div class="tag">AISLE A2</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                                <div class="actionItem">
                                    <div class="image imageBlueBlockers"></div>
                                    <div class="title">Uvex Skyper Blue Light&nbsp;Glasses</div>
                                    <div class="summary">Uvex Skyper Blue Light Blocking Computer Glasses feature an orange lens with Spectrum Control Technology (SCT) to absorb your computer's blue light. This improves your focus, reduces eye fatique, and helps inhibit vision problems like cataracts and age-related macular degeneration.</div>
                                    <div class="price">$10</div>
                                    <div class="tags">
                                        <div class="tag">EYE CARE</div>
                                        <div class="tag">AISLE C2</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="recommendation=='wellness'" >
                            <div class="summary">Get better sleep by <u>getting your body to help.</u></div>
                            <div class="copy">Your body knows to sleep when it's dark, so you can encourage it by easing into nighttime. Light stops your body releasing melatonin, a hormone that naturally promotes sleep.</div>
                            <div class="howTitle">You can do this by</div>
                            <div class="how copy">
                                Use natural supplements to help you fall asleep.<br><br>
                                Follow a bedtime exercise routine.<br><br>
                                Reduce stress with a meditation at bedtime.
                            </div>
                            <div class="readMore">
                                <div class="readMoretitle">Read More Online</div>
                                <div class="readMoreLink">cvshealth.com/sleep</div>
                            </div>
                            <div class="actions">
                                <div class="howTitle">Use natural supplements to help you fall asleep:</div>
                                <div class="actionItem">
                                    <div class="image imageVitaFusion"></div>
                                    <div class="title">VitaFusion Melatonin&nbsp;Gummies</div>
                                    <div class="summary">Melatonin is a hormone that naturally occurs in your body when it wants you to go to sleep.</div>
                                    <div class="price">$10</div>
                                    <div class="tags">
                                        <div class="tag">PHARMACY</div>
                                        <div class="tag">AISLE A1</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                                <div class="actionItem">
                                    <div class="image imageSleepAid"></div>
                                    <div class="title">Luna Sleep&nbsp;Aid</div>
                                    <div class="summary">The LUNA formula starts with Melatonin to help reset your body's natural sleep cycle and a blend of calming herbs, including extracts of Chamomile, Lemon Balm, Passionflower, Hops and Valerian, to help relax both body and mind at bedtime.</div>
                                    <div class="price">$22</div>
                                    <div class="tags">
                                        <div class="tag">PHARMACY</div>
                                        <div class="tag">AISLE A1</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                                <div class="actionItem">
                                    <div class="image imageChamomile"></div>
                                    <div class="title">Nature's Way Chamomile</div>
                                    <div class="summary">This provides a refresing and relaxing sleep and has a relaxing effect on the digestive track.</div>
                                    <div class="price">$7</div>
                                    <div class="tags">
                                        <div class="tag">VITAMINS</div>
                                        <div class="tag">AISLE A2</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                                <hr>
                                <div class="howTitle">FOLLOW A BEDTIME EXERCISE ROUTINE:</div>
                                <div class="actionItem">
                                    <div class="title">Yoga Nidra: Sacred&nbsp;Sleep</div>
                                    <div class="summary">Jennifer Piercy takes you through a beautifully guided Yoga Nidra for Sleep meditation. Her deeply calming voice penetrates into your very soul, instilling a sense of internal peace and leaving you feeling incredibly relaxed, present and rejuvenated.<br>Found on Youtube.                                </div>
                                </div>
                                <div class="howTitle">REDUCE STRESS BEFORE BED:</div>
                                <div class="actionItem">
                                    <div class="title">Calm Meditation & Sleep&nbsp;App</div>
                                    <div class="summary">Calm includes guided meditations and Sleep Stories to help you reduce anxiety, lower stress and sleep better.<br>In most app stores.</div>
                                </div>
                                <div class="actionItem">
                                    <div class="title">Dr. Mary T. Wegman - Sleep&nbsp;Expert</div>
                                    <div class="summary">Call <b>781.232.3432</b> for a booking.</div>
                                </div>
                                
                                
                            </div>
                        </template>
                        <template v-if="recommendation=='environment'" >
                            <div class="summary">Get better sleep by <u>making your bedroom a place for better rest.</u></div>
                            <div class="copy">Your body knows to sleep when it's dark, so you can encourage it by easing into nighttime. Light stops your body releasing melatonin, a hormone that naturally promotes sleep.</div>
                            <div class="howTitle">You can do this by</div>
                            <div class="how copy">
                                Eliminating sound & light disturbances in your bedroom.<br><br>
                                Adjusting the temperature in your bedroom to slightly cooler than you’d normally like it.
                            </div>
                            <div class="readMore">
                                <div class="readMoretitle">Read More Online</div>
                                <div class="readMoreLink">cvshealth.com/sleep</div>
                            </div>
                            <div class="actions">
                                <div class="howTitle">Eliminate sound disturbances in your bedroom:</div>
                                <div class="actionItem">
                                    <div class="title">Relax Melodies&nbsp;App</div>
                                    <div class="summary">Discover the magic of sleep meditations. You’ll love combining your sounds to our guided meditations, which are specifically designed to help you sleep.</div>
                                </div>
                                <div class="actionItem">
                                    <div class="image imageEarplugs"></div>
                                    <div class="title">Howard Leight Ear&nbsp;Plugs</div>
                                    <div class="summary">Howard Leight earplugs use advanced technology to block noise and manage sound in some of the world's most acoustically challenging environments.</div>
                                    <div class="price">$5</div>
                                    <div class="tags">
                                        <div class="tag">PERSONAL CARE</div>
                                        <div class="tag">AISLE C2</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                                <div class="actionItem">
                                    <div class="image imageLectrofan"></div>
                                    <div class="title">LectroFan White Noise&nbsp;Machine</div>
                                    <div class="summary">Create a soothing state of mind with this LectroFan white noise machine. Its 20 distinct digital sounds, which includes 10 different fan sounds and 10 types of pure white noise, let you mask environmental noise. </div>
                                    <div class="price">$40</div>
                                    <div class="tags">
                                        <div class="tag">ELECTRONICS</div>
                                        <div class="tag">AISLE D1</div>
                                        <div class="tag">IN STOCK</div>
                                    </div>
                                </div>
                                <hr>
                                <div class="howTitle">Eliminate light disturbances in your bedroom:</div>
                                <div class="actionItem">
                                    <div class="title">Sebastian Insulated Blackout&nbsp;Curtains</div>
                                    <div class="summary">Sleep soundly and block the harsh sunlight with the Sebastian Rod Pocket Insulated Total Blackout Window Curtain Panel.</div>
                                    <div class="price">$40</div>
                                </div>
                                <div class="actionItem">
                                    <div class="image imageMask"></div>
                                    <div class="title">Nidra Deep Rest Eye&nbsp;Mask</div>
                                    <div class="summary">Melatonin is a hormone that naturally occurs in your body when it wants you to go to sleep.</div>
                                    <div class="price">$12</div>
                                </div>
                                <hr>
                                <div class="howTitle">LOWER THE TEMPERATURE!:</div>
                                <div class="actionItem">
                                    <div class="image imageNest"></div>
                                    <div class="title">Nest Smart&nbsp;Thermostat</div>
                                    <div class="summary">Adjusting the temperature in your bedroom to slightly cooler than you’d normally like it helps with sleep. Nest can turn it down when you're sound asleep.</div>
                                    <div class="price">$170</div>
                                </div>
                                
                                
                                
                            </div>
                        </template>
                        
                    </div>
                </transition>
            </div>
            
            <div class="nav" :class="{slideOut:isPrinting||!actionSelected}">
                <!-- <input v-if="$isBooth" type="button" value="Print It!" @click="printPress" class="printBtn"> -->
                <input v-if="$isBooth" type="button" value="Wrap it Up" @click="signupPress" class="printBtn">
                <input v-else type="button" value="Wrap it up" @click="signupPress" class="printBtn">
                <input type="button" value="Meet Health Coach" @click="coach" class="emailBtn">
            </div>
        </div>
        
    </div>
           
</template>

<script>
import auth from '@/auth'
import Pinwheel from '../components/Pinwheel'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
import db from '../db' 
import $ from 'jquery'

export default {
    name: 'ReportPage',
    props: {},
    mixins: [],
    data() {
        return {
            user: null,
            happinessTell: null,
            goal: null,
            positives: null,
            opportunities: null,
            energy: null,
            pain: null,
            stress: null,
            exercise: null,
            food: null,
            toxins: null,
            sleep: null,
            sleepDeepDive: {
                quantity: null,
                regularity: null,
                behavior: null
            },
            recommendation: null,
            actionSelected: this.$isBooth,
            isPrinting: this.$isBooth,
            printMode: this.$isBooth,
            didScroll: this.$isBooth
        }
    },
    components: {
        Pinwheel
    },
    ready() {
    },
    methods: {
        captureDom(dom, callback) {
            let shareContent = dom;
            let width = shareContent.offsetWidth;
            let height = shareContent.offsetHeight;
            let offsetTop = 0//shareContent.offsetTop;
            let scaleBy = 1;
            let canvas = document.createElement("canvas"); 
            canvas.id = "capture-canvas";
            let context = canvas.getContext("2d");
            canvas.width = width * scaleBy;
            canvas.height = (height + offsetTop) * scaleBy;
            context.scale(scaleBy, scaleBy);
            let opts = {
                allowTaint: true,
                tainttest: true,
                scale: scaleBy,
                canvas: canvas,
                logging: false, 
                width: width,
                height: height
            };
            html2canvas(shareContent, opts).then(canvas => {
                callback(canvas);
            });
        },
        actionCard(event) {
            this.$sound('type')
            this.actionSelected = true
        },
        signupPress() {
            let user = auth.currentUser()
            if (!user || user.email) { // Either there is no UID to work with, or they already are registered
                // END AND EXIT
                this.$sound('chime')
                this.$router.replace('/logout')
            } else {
                // SIGN THEM UP
                this.$sound('type')
                this.$router.replace('/signup')
            }
        },
        printPress() {
            this.$sound('type')
            this.isPrinting = true
            this.$waitAudio(true)
            setTimeout(() => {
                this.printPage()
            }, 1000)
        },
        printPage() {
            // PRINT RECEIPT
            this.printMode = true
            setTimeout(() => {
                let clone = this.$refs.reportRef
                let uid = this.$store.state.profile.uid;
                let storageRef = db.storage().ref().child(`${uid}.png`)

                this.captureDom(clone, (canvas) => {
                    canvas.toBlob((blob) => {
                        storageRef.put(blob).then((snapshot) => {
                            console.log(snapshot);
                            snapshot.ref.getDownloadURL().then((downloadURL) => {
                                db.ref('prints').child(uid).set({
                                    url: downloadURL,
                                    did_print: false,
                                    created_at: db.timestamp()
                                })
                                // ALLOW EXPLORATION OF RECEIPT
                                this.$waitAudio(false)
                                this.printMode = false
                                this.actionSelected = false
                                this.setupScrollTrigger()
                                this.isPrinting = false
                                console.log('Receipt ready!')
                            })
                        })
                    })
                })
            }, 1000)
        },
        setupScrollTrigger() {
            this.didScroll = false
            $('html').scrollTop(0)
            console.log($('html'))
        },
        coach() {
            this.$sound('type')
            this.$animateLEDS("sweep", "#FF4500")
        },
        setGoal() {
            let str = "your overall well-being"
            if (this.energy < this.stress && this.energy < this.pain) {
                str = "increase your energy"
            } else if (this.pain < this.stress && this.pain <= this.energy) {
                str = "relieve some pain"
            } else {
                str = "lower your stress level"
            }
            this.goal = str
        },
        setPositives() {
            let str
            let arr = []
            if (this.smoking == -2) arr.push("not smoking")
            if (this.exercise == 2) arr.push("exercising regularly")
            if (this.food == 2) arr.push("eating healthy")
            if (this.toxins >= 1) arr.push("limiting toxins like caffeine and alcohol")
            // if (this.sleep == 2) arr.push("sleeping well") // in proto everyone has sleep trouble ;)

            // Overall score based on how many net positives you've accrued
            if (arr.length > 4) str = "Overall you’re doing great! "
            else if (arr.length > 3) str = "You’re so close to feeling the best you can! "
            else str = "You’re probably not feeling the best you could but that means you have so much opportunity to feel better! "

            if (arr.length > 0) {
                str += "You're "
                for (let i = 0; i < arr.length; i++) {
                    const positive = arr[i];
                    str += "<u>"+positive+"</u>"
                    if (arr.length > 1) {
                        if (i == arr.length-2) {
                            str += " and "
                        } else if (i < arr.length-2) {
                            str += ", "
                        }
                    }
                }
                str += " which is critical. "
            }
            this.positives = str
        },
        setOpportunities() {
            let str = "But, <u>better sleep</u> could help to <u>"+this.goal+"</u> "
            let arr = []
            if (this.smoking > -2) arr.push("not smoking")
            if (this.exercise < 2) arr.push("exercising regularly")
            if (this.food < 2) arr.push("eating healthy")
            if (this.toxins < 1) arr.push("limiting toxins like caffeine and alcohol")
            // if (this.sleep < 2) arr.push("sleeping well") // in proto everyone has sleep trouble ;)
            if (arr.length > 0) {
                str += "(Plus maybe "
                for (let i = 0; i < arr.length; i++) {
                    const negative = arr[i];
                    str += "<u>"+negative+"</u>"
                    if (arr.length > 1) {
                        if (i == arr.length-2) {
                            str += " and "
                        } else if (i < arr.length-2) {
                            str += ", "
                        }
                    }
                }
                str += ")."
            }
            this.opportunities = str
        },
        setRecommendation() {
            let str

            // --------------------------------
            // SHAUN SLEEP FORMULA
            //
            this.sleepDeepDive.regularity
            this.sleepDeepDive.behavior
            if (this.sleepDeepDive.regularity > 0) {
                if (this.sleepDeepDive.behavior > 0) {
                    str = "environment"
                } else {
                    str = "wellness"
                }
            } else {
                if (this.sleepDeepDive.behavior > 0) {
                    str = "discipline"
                } else {
                    str = "discipline"
                }
            }
            this.recommendation = str
        }
    },
    computed: {
    },
    watch: {
        userData(val) {
            console.log(val);
            if (val.Introduction) {
                this.happinessTell = val.Introduction['happinessTell']?val.Introduction['happinessTell']:''
            }
            if (val.Physical) {
                this.energy = val.Physical['energy']?val.Physical['energy']:0
                this.stress = val.Physical['stress']?val.Physical['stress']:0
                this.pain = val.Physical['pain']?val.Physical['pain']:0
                this.smoking = val.Physical['smoking']?val.Physical['smoking']:0
                this.exercise = val.Physical['movement']?val.Physical['movement']:0
                this.food = val.Physical['food']?val.Physical['food']:0
                this.toxins = ((val.Physical['drinks'].Alcohol + val.Physical['drinks'].Caffeine)/2)*-1
                this.sleep = val.Physical['sleep']?val.Physical['sleep']:0
                this.sleepDeepDive.quantity = val.Physical['sleep_sleepAmount:']?val.Physical['sleep_sleepAmount:']:0
                this.sleepDeepDive.regularity = val.Physical['sleep_bedtime:']?val.Physical['sleep_bedtime:']:0
                this.sleepDeepDive.behavior = val.Physical['sleep_bedroomBehavior:']?val.Physical['sleep_bedroomBehavior:']:0
            }
            this.setGoal()
            this.setPositives()
            this.setOpportunities()
            this.setRecommendation()
        }
    },
    created() {
    },
    destroyed() {
    },
    mounted() {
        auth.getUserData()

        if (this.$isBooth) {
            this.printPage()
        } else {
            this.setupScrollTrigger()
        }
        var s = 0
        window.onscroll = (e)=> {
            if (!this.isPrinting) {
                s++
                if (s > 1) {
                    this.didScroll = true
                    window.onscroll = null
                }
            }
        }
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";

#printingContainer {
    padding: 50vw 8vw 8vw;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    background-color: $color-cream;
    text-align: center;
    overflow: hidden;
    h5 {
        color: $color-gray;
        font-size: 5vw;
    }
}

#PrintContainer {
    opacity: 1;
    top: 0;
    left: 0;
    right: 0;
    padding: 8vw;
    min-height: 1920px;
    text-align: center;
    background-color: $color-cream;
    overflow-x: hidden;
    hr {
        margin-top: -3vw;
    }
    .snapshotContainer {
        margin-bottom: 9vw;
        
        > .title {
            margin-top: 2vw;
            height: 10vw;
            border-radius: 5vw;
            text-align: left;
            position: relative;
            .icon {
                display: inline-block;
                height: 10vw;
                width: 10vw;
                background: $color-blue;
                border-radius: 50%;
                background-image: url(../assets/static/physical_ico.svg);
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 60%;
            }
            .titleText {
                padding-left: 2.5vw;
                position: absolute;
                top: 0;
                display: inline-block;
                line-height: 10vw;
                font-family: "Walsheim";
                text-transform: uppercase;
                font-size: 3vw;
                letter-spacing: .2vw;
            }
        }

        .headline {
            font-size: 7vw;
            margin: 5vw;
            margin-top: 4vw;
            margin-left: 0;
            text-align: left;
        }
        > .summary, .bodyTalk {
            font-size: 3vw;
            font-weight: 500;
            text-align: left;
            margin-bottom: 6vw;
        }
        .bodyTalkTitle {
            font-size: 4vw;
            text-align: left;
            margin-bottom: 2vw;
        }
    }
    .actionsContainer {
        text-align: center;
        position: relative;
        min-height: 90vw;
        padding-bottom: 24vw;
        > .smallTitle {
            display: inline-block;
            font-size: 3vw;
            letter-spacing: .2vw;
            text-transform: uppercase;
            font-family: "Walsheim";
            color: $color-dark;
            font-weight: 700;
            padding: 0 7vw;
            min-width: 40vw;
            margin: 5vw 0 3vw;
            color: $color-darkerCream;
        }
        > .title {
            margin-top: 2vw;
            height: 10vw;
            border-radius: 5vw;
            text-align: left;
            position: relative;
        }
        > .summary {
            font-size: 4vw;
            margin-bottom: 7vw;
        }
        &.sleepActions {
            padding-bottom: 15vw;
            > .title {
                margin-top: 6vw;
                height: 10vw;
                border-radius: 5vw;
                text-align: left;
                position: relative;
                .icon {
                    display: inline-block;
                    height: 10vw;
                    width: 10vw;
                    background: $color-darkBlue;
                    border-radius: 50%;
                    background-image: url(../assets/static/sleep_ico.svg);
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: 100%;
                }
                .titleText {
                    padding-left: 2.5vw;
                    position: absolute;
                    top: 0;
                    display: inline-block;
                    line-height: 10vw;
                    font-family: "Walsheim";
                    text-transform: uppercase;
                    font-size: 3vw;
                    letter-spacing: .2vw;
                }
            }
            > .summary {
                font-size: 7vw;
                margin: 4vw 5vw 6vw;
                margin-left: 0;
                text-align: left;
            }
            .copy {
                text-align: left;
                font-size: 3vw;
                font-weight: 500;
            }
            .howTitle {
                text-align: left;
                font-family: "Walsheim";
                font-weight: 700;
                font-size: 2.5vw;
                letter-spacing: .3vw;
                text-transform: uppercase;
                margin: 4vw 0;
                color: $color-darkBeige;
            }
            .readMore {
                margin: 5vw 0;
                padding: 3vw;
                background: $color-darkCream;
                font-size: 4vw;
                border-radius: 2vw;
                .readMoreLink {
                    font-family: "Walsheim";
                    font-size: 2.5vw;
                    font-weight: 700;
                    letter-spacing: .2vw;
                    opacity: .65;
                    margin-top: 5px;
                }
            }
            .actions {
                .howTitle {
                    margin-top: 7vw;
                    margin-bottom: 3vw;
                }
            }
            .actionItem {
                text-align: left;
                margin-bottom: 7vw;
                .image {
                    float: left;
                    height: 12vw;
                    width: 24vw;
                    background: $color-cream;
                    margin-bottom: 2vw;
                    margin-right: 2vw;
                    border-radius: 2vw;
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: cover;
                    border: solid 2px $color-cream;
                    &.imageSleepAid {
                        background-image: url(../assets/static/sleepAid.png);
                    }
                    &.imageVitaFusion {
                        background-image: url(../assets/static/vitaFusion.png);
                    }
                    &.imageChamomile {
                        background: white;
                        background-image: url(../assets/static/chamomile.jpg);
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center center;
                    }
                    &.imageBigelow {
                        background-image: url(../assets/static/bigelow.jpg);
                    }
                    &.imageDiffuser {
                        background-image: url(../assets/static/diffuser.jpg);
                    }
                    &.imageEarplugs {
                        background-image: url(../assets/static/earplugs.jpg);
                    }
                    &.imageLectrofan {
                        background-image: url(../assets/static/lectrofan.jpg);
                    }
                    &.imageMask {
                        background-image: url(../assets/static/mask.jpg);
                    }
                    &.imageNest {
                        background-image: url(../assets/static/nest.jpg);
                    }
                    &.imageBlueBlockers {
                        background-image: url(../assets/static/blueBlockers.jpg);
                    }
                }
                .title {
                    font-size: 5vw;
                    margin: 2vw 0;
                }
                .summary {
                    font-family: "Walsheim";
                    font-size: 3vw;
                    font-weight: 300;
                    margin-right: 0;
                }
                .link {
                    margin: 2vw 0;
                    font-size: 2.5vw;
                    font-weight: 500;
                }
                .price {
                    display: none;
                    // font-family: "Walsheim";
                    // font-size: 2.5vw;
                    // text-transform: uppercase;
                    // letter-spacing: .1vw;
                    // margin: 2vw 0;
                    // opacity: .5;
                    // float: right;
                    // height: 15vw;
                    // width: 15vw;
                    // background: $color-darkCream;
                    // border-radius: 8vw;
                    // line-height: 15vw;
                    // text-align: center;
                    // font-size: 4vw;
                }
                .price:before {
                    content: 'Typically costs';
                }
                .tags {
                    margin-bottom: 18vw;
                }
                .tag {
                    float: left;
                    padding: 2vw 4vw;
                    border-radius: 4vw;
                    margin-top: 3vw;
                    margin-right: 1.5vw;
                    font-family: "Walsheim";
                    font-size: 2vw;
                    line-height: 2.5vw;
                    letter-spacing: .2vw;
                    background-color: $color-blueBlue;
                    &:first-child {
                        background-color: $color-darkCream;
                    }
                }
            }
        }
        .scrollInstruction {
            position: absolute;
            width: 100%;
            background: $color-cream;
            top: -2vw;
            height: 25vw;
            font-size: 5vw;
            padding-top: 5vw;
            color: $color-darkerCream;
            transition: opacity .5s ease;
            .arrow {
                margin-top: 2vw;
                margin-left: auto;
                margin-right: auto;
                width: 6vw;
                height: 6vw;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                background-image: url(../assets/static/BackArrow.svg);
                transform: rotate(-90deg);
                opacity: .4;
            }
            &.hidden {
                opacity: 0;
            }
        }
        .actionCardsContainer {
            position: absolute;
            padding: 5vw;
            border: dashed 4px $color-darkKeyboard;
            border-radius: 5vw;
            text-align: left;
            white-space: nowrap;
            .card {
                display: inline-block;
                height: 47.5vw;
                width: 34vw;
                margin-right: 5vw;
                border-radius: 2vw;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                opacity: .35;
                &:last-child {
                    margin-right: 0;
                }
                &.sleepCard {
                    background-image: url(../assets/static/sleepCard.png);
                    opacity: 1;
                }
                &.eatCard {
                    background-image: url(../assets/static/eatCard.png);
                }
                &.moveCard {
                    background-image: url(../assets/static/moveCard.png);
                }
                &.stressCard {
                    background-image: url(../assets/static/stressCard.png);
                }
            }
        }
    }
    .nav {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: $color-dark;
        padding: 5vw 7vw;
        text-align: center;
        transition: bottom .5s ease-out;
        input {
            display: inline-block;
            height: 10vw;
            font-weight: 700;
            font-size: 28px;
            letter-spacing: .2vw;
            line-height: 10vw;
            text-transform: uppercase;
            width: 39vw;
            border-radius: 5vw;
            margin: 2vw;
            color: $color-dark;
            background: $color-darkCream;
            &.printBtn {
                background: $color-white;
            }
        }
        &.slideOut {
            bottom: -25vw;
            input.printBtn {
                background: $color-dark;
                color: $color-white;
            }
        }
    }
    &.forPrint {
        color: black;
        background-color: $color-white;
        u { text-decoration: none; }
        .snapshotContainer {
            > .title {
                color: black;
                background-color: white;
                // border: 4px solid black;
            }
            .icon {
                background-color: black;
                background-image: url(../assets/static/physical_icoPrint.svg);
            }
        }
        .actionsContainer {
            padding-bottom: 0;
            > .title {
                font-size: 5vw;
                color: black;
                background-color: white;
                .icon {
                    background-color: black;
                    background-image: url(../assets/static/sleep_icoPrint.svg);
                }
            }
            
            .readMore {
                background-color: #BBB;
            }
            .readMoreLink {
                opacity: 1 !important;
            }
        }
        .howTitle {
            color: black !important;
        }
        .price {
            color: white;
            background: black !important;
        }
        .tag {
            background-color: white !important;
            border: 4px solid black;
            color: black;
            &:first-child {
                color: white;
                background-color: black !important;
            }
        }
    }
}

</style>